<template>
  <div class="c-teacher-wrong">
    <header>
      <div class="wrong-bg">
        <i class="wrong-bg__icon"/>
        <p class="wrong-bg__title">
         班级共性错题（共计{{wrongData.length}}题）
        </p>
      </div>
      <div class="wrong-operate">
        <div class="wrong-operate__left">
        至少2人答错的目才会进入共性错题，优先为您展示班级错误人数更多和正答率更低的题目
        </div>
        <div class="wrong-operate__right">
        <!-- <div class="right-content"> -->
          <div class="right-content__selected" v-show="topic.length">
            已选择<span class="blue">{{topic.length}}</span>个共性错题
          </div>
          <el-button class="right-content__cancel" v-show="topic.length"
          @click="handleCancel">取消</el-button>
          <el-tooltip effect="dark" content="请勾选需要布置的题目" placement="top" v-if="isDisabled">
            <el-button type="primary" class="right-content__consolidate"
            icon="el-icon-plus" @click="doExercises"
            :class="isDisabled?'right-content__disabled':''"
            >
              布置错题巩固练习
            </el-button>
          </el-tooltip>
          <el-button type="primary" class="tooltip-hover" icon="el-icon-plus" v-else
            @click="doExercises">
              布置错题巩固练习
          </el-button>
        <!-- </div> -->
        </div>
      </div>
    </header>

    <!--table列表-->
    <section>
       <correlation
        :classType='classType'
        ref="knowledgeList"
        @multipleSelection="multipleSelection"
        :overviewData="overviewData"
        :knowledgeWrongList="wrongData"/>
    </section>
    <!-- 布置错题巩固弹框 -->
    <assign-mistakes
      :isAssignShow.sync="isAssignShow"
      :topic='topic'
      @clearchange="clearchange"
      :requestCondition="requestCondition"
    />
    <knowledge-dialog
      :dialogVisible="dialogVisible"
      @handleClose ="handleGoArrange"
      @handleClean="handleNoArrange"
    />
  </div>
</template>

<script>
// import Correlation from '@/components/correlation.vue';
import Correlation from './correlation.vue';
import AssignMistakes from '../../components/assign-mistakes.vue';
import KnowledgeDialog from '../../components/knowledge-dialog.vue';
import { getCommonWrongQuestion } from '@/api/pt';

const CLASS_TYPE = 3; // 3为练习中心错题
export default {
  name: 'PracticeOverviewPoint',
  components: {
    Correlation,
    AssignMistakes,
    KnowledgeDialog,
  },
  props: {
    overviewData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      wrongData: [],
      classType: CLASS_TYPE,
      dialogVisible: false,
      isAssignShow: false,
      topic: [],
      requestCondition: {
        classType: 2,
        testType: 4,
      },
    };
  },
  computed: {
    isDisabled() {
      return !this.topic.length > 0;
    },
  },
  watch: {
    overviewData() {
      this.commonWrong();
    },
  },
  methods: {
    commonWrong() {
      getCommonWrongQuestion({
        class_id: this.overviewData.class_id,
        course_id: this.overviewData.evaluate_id,
      }).then(({ data }) => {
        this.wrongData = data;
      });
    },
    rowToggle(index, row) {
      const { wrongTable } = this.$refs;
      // 获取表格列包含isExpanded进行样式切换
      const expanded = [...this.$refs.wrongTable.$el.getElementsByClassName('el-table__row')];
      expanded.forEach((child, idx) => {
        if (idx === index) {
          if (!child.className.includes('expanded')) {
            this.$set(row, 'isExpanded', 1);
          } else {
            this.$set(row, 'isExpanded', 0);
          }
        }
      });
      wrongTable.toggleRowExpansion(row);
    },
    handleCancel() {
      this.dialogVisible = true;
    },
    handleNoArrange() {
      // 清空所有选中数据
      this.dialogVisible = false;
      this.$refs.knowledgeList.clearchange();
    },
    clearchange() {
      this.$refs.knowledgeList.clearchange();
    },
    handleGoArrange() {
      // 直接关闭
      this.dialogVisible = false;
    },
    multipleSelection(val) { // 将选中的题目复制给父组件
      this.topic = val;
    },
    doExercises() {
      if (this.topic.length > 0) {
        this.$set(this.requestCondition, 'className', this.overviewData.class_name);
        this.$set(this.requestCondition, 'classId', this.overviewData.class_id);
        this.$set(this.requestCondition, 'subjectName', this.overviewData.subject_name);
        this.isAssignShow = true;
      }
    },
  },
  mounted() {
    this.commonWrong();
  },
};
</script>

<style lang="scss" scoped>
.c-teacher-wrong{
  box-sizing: border-box;
  padding:45px 20px 32px 20px;
  background: #fff;
  header{
  .wrong-bg{
   display: flex;
   align-items: flex-end;
   position: relative;
   &__icon{
    display: block;
    background:url('~@/views/pt/images/class_bg.png');
    background-size:cover;
    width:38px;
    height:29px;
   }
   &__title{
    position: absolute;
    width: 250px;
    font-size: 17px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.8);
    left:15px
   }
   &__remark{
    position: absolute;
    top:5px;
    font-size: 13px;
    width: 600px;
    font-family: PingFangSC-Medium, PingFang SC;
    color:#999;
   }
  }
  .wrong-operate{
    margin-top:15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
   &__left{
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.6);
    margin-left:15px;
   }
   &__right{
    display: flex;
    align-items: center;
    .right-content{
     &__selected{
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #000000;
      margin-right:16px;
      .blue{
        color: #1989FA;
      }
     }
     &__cancel{
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #606266;
      margin-right:16px;
      width: 120px;
     }
     &__consolidate{
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      width: 181px;
     }
     &__disabled{
      cursor: not-allowed;
      color: #FFF;
      background-color: rgba(17, 31, 44, 0.12);
      border-color:#fff;
     }
    }
   }
  }
 }
 section{
    margin-top:32px;
    .btn-pos{
      margin-right:8px;
    }
  }
  /deep/ .el-table__expanded-cell{
    padding:0;
  }
  /deep/ .el-button--primary.is-disabled{
    color: #FFF;
    background-color: rgba(17, 31, 44, 0.12);
    border-color:#fff;
  }
}
</style>
